(async () => {

  if (!customElements.get('product-card-swiper')) {

    const { default: Swiper, Navigation, Pagination } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination
    ]);

    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-product-card]');

        this.swiperOptions = {
          watchOverflow: true,
          threshold: 10,
          // preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerView: 1,
          spaceBetween: 0,
          direction: 'horizontal'
        };

        // Check if we have extra options on the HTML
        if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
          const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.productCardSwipersInitialized = false;
        let self = this;

        window.addEventListener('load', function() {
          self.toggleProductCardSwiper();
        });
        window.addEventListener('resize', function() {
          self.toggleProductCardSwiper();
        });
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        this.swiperElement.classList.remove('swiper-hover');
      }

      destroy() {
        this.swiperInstance.destroy();
        this.swiperElement.classList.add('swiper-hover');
      }

      toggleProductCardSwiper() {

        if ( window.innerWidth < 1024 ) {
          // Init Product Link swiper
          if (!this.productCardSwipersInitialized) {
            this.init();
            this.productCardSwipersInitialized = true;
          }
        } else {
          if (this.productCardSwipersInitialized && this.swiperInstance) {
            // Destroy swiper
            this.destroy();
            this.productCardSwipersInitialized = false;
          }
        }
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('product-card-swiper', ProductCard);

  }

})();
